import { lazy } from 'react';
import { ExperimentOutlined } from '@ant-design/icons';
import { AppNames } from '@tools/shared';
import { AppRouter } from '@tools/ui/types';

export const BASE_PATH = '/melio-llm-playground';

const MainView = lazy(() =>
  import('./MainView').then((m) => ({ default: m.default }))
);

export const melioLlmPlaygroundRoutes: AppRouter = {
  modules: [
    {
      redirectFrom: [BASE_PATH]
    },
    {
      name: AppNames.MelioLlmPlayground,
      path: `${BASE_PATH}/main`,
      component: MainView,
      exact: true,
      icon: ExperimentOutlined,
      pages: []
    }
  ]
};
